<template>

<div class="container-fluid p-0">
    <div class="review-wrap mb-4">

       <div class="row" v-if='!isReady && user'>
            <div class="col-12 text-center">
                <img src='/resources/loader.svg' width="75px">
            </div>
        </div>

        <div v-if='isReady'>
            <div id="your-review" class="d-flex justify-content-between align-items-center align-items-sm-end flex-column flex-sm-row">
                <h4 @click='showForm = !showForm' class="secondary-title pointer mb-1 mb-sm-0">
                   Your review
                </h4>
                <button v-if='user' @click='showForm = !showForm' class="btn btn-primary">
                    <span v-if='!showForm' class="d-flex align-items-center text-main">
                        <span :class="['icon mr-1', hasReview ? 'icon-gear' : 'icon-plus-round' ]"></span>
                        {{ hasReview ? "Edit your review" : "Add Review" }}
                    </span>
                    <span v-if='showForm' class="d-flex align-items-center">
                        <span class="icon icon-x-round mr-1"></span>
                        Close
                    </span>
                </button>
            </div>
            <transition name="slide">
                <div v-if='showForm && user' class="row pt-5 review-show">
                    <div class="col-12 col-md-4 mb-5 mb-md-0 pr-md-4">
                        <div class='form-group'>
                            <label class="label pl-0 mb-0 w-100 d-flex justify-content-between" for='r1'>
                                <span class="text">Accuracy</span>
                                <span class="num text-contrast">{{ yourReview.r1 }} / 10</span>
                            </label>
                            <input @change='recalculate' type='range' step=1 min=1 max=10 class='custom-range rating-range' id='r1' v-model.number='yourReview.r1'/>
                        </div>

                        <div class='form-group'>
                            <label class="label pl-0 mb-0 w-100 d-flex justify-content-between" for='r2'>
                                <span class="text">User Interface</span>
                                <span class="num text-contrast">{{ yourReview.r2 }} / 10</span>
                            </label>
                            <input @change='recalculate' type='range' step=1 min=1 max=10 class='custom-range rating-range' id='r2' v-model.number='yourReview.r2'/>
                        </div>

                        <div class='form-group'>
                            <label class="label pl-0 mb-0 w-100 d-flex justify-content-between" for='r3'>
                                <span class="text">Performance</span>
                               <span class="num text-contrast">{{ yourReview.r3 }} / 10</span>
                            </label>
                            <input @change='recalculate' type='range' step=1 min=1 max=10 class='custom-range rating-range' id='r3' v-model.number='yourReview.r3'/>
                        </div>

                        <div class='form-group'>
                            <label class="label pl-0 mb-0 w-100 d-flex justify-content-between" for='r4'>
                                <span class="text">Innovation</span>
                                <span class="num text-contrast">{{ yourReview.r4 }} / 10</span>
                            </label>
                            <input @change='recalculate' type='range' step=1 min=1 max=10 class='custom-range rating-range' id='r4' v-model.number='yourReview.r4'/>
                        </div>

                        <h6 class="mb-0 d-flex justify-content-between your-rating-preiew">
                            <span>Your total rating:</span> 
                            <span class="text-contrast">{{ yourReview.rating }} / 10</span>
                        </h6>
                    </div>

                    <div class="col-12 col-md-8">

                        <div class='input-group mb-4'>
                            <label class="label d-flex justify-content-between align-items-center w-100 mb-0" for='title'>
                                Review Title 
                                <span>Minimum 5 symbols: {{ yourReview.title.length }} / 60</span>
                            </label>
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <span class="icon icon-label"></span>
                                </span>
                            </div>
                            <input v-model.trim='yourReview.title' id='title' class='form-control'>
                        </div>

                        <div class='input-group mb-3'>
                            <label class="label d-flex justify-content-between align-items-center w-100 mb-0" for='review'>
                                Your review 
                                <span>Minimum 10 symbols : {{ yourReview.review.length }} / 500</span>
                            </label>
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <span class="icon icon-writing"></span>
                                </span>
                            </div>
                            <textarea v-model.trim='yourReview.review' id='review' 
                                      class='form-control' >
                            </textarea>
                        </div>

                        <div class="text-center text-md-left">
                            <button @click='save()' class='btn btn-primary mb-3'>
                                {{ hasReview ? "Update review" : "Create Review" }}
                            </button>
                        </div>

                    </div>
                </div>
            </transition>
        </div>

         <div class="row mt-4" v-if='!user'>
            <div class="col-12">
                <p>Please login to leave a review or comment.</p>
                <a href='/login' class="btn btn-primary">Login</a> or 
                <a href='/register' class="btn btn-primary">Register</a>
            </div>
        </div>
    </div>

    <div v-if='isReady && reviews.length' class="review-wrap review-holder">
        <div v-for='(r,i) in reviews' class="review" itemprop="review" itemscope itemtype="https://schema.org/Review">
                    
            <div class="d-flex flex-column flex-md-row align-items-center align-items-md-start">
                <div class="user-avatar mr-md-3 text-center">
                    <img :src='r.avatar ? r.avatar : "/resources/user.jpg"' class="img-fluid" >
                </div>
                <div class="user-review w-100">
                    <div class="d-flex align-items-center justify-content-between flex-column flex-md-row mb-2">
                        <strong class="d-block secondary-title" itemprop="author">{{ r.author }}</strong>
                            
                        <small class="text-muted d-flex flex-column flex-md-row mt-2 justify-content-center">
                            <span v-if='r.verified == 1' class='badge badge-contrast badge-verify mr-md-3 mb-1 mb-md-0'>
                                <span class="d-flex align-items-center">
                                    <span class="icon icon-checkmark-round mr-1"></span>
                                    This review is verified.
                                </span>
                            </span>

                            <span @click='editYourReview' 
                                v-if='r.id == yourReview.id' 
                                class="pointer edit d-flex justify-content-center align-items-center mr-md-3">
                                <span class="icon icon-gear mr-1"></span>
                                <span class="text">Edit the review</span>
                            </span>
                            <span @click='reportReview(r)' 
                                v-if='r.id != yourReview.id' 
                                class="pointer edit d-flex justify-content-center align-items-center mr-md-3">
                                <span class="icon icon-pin mr-1"></span>
                                <span class="text">Report this review</span>
                            </span>
                            <span class="d-flex align-items-center">
                                <span class="icon icon-calendar1 mr-1"></span>
                                <span itemprop="datePublished" :content="r.created_at">{{ r.created_at }}</span>
                            </span>
                        </small>
                    </div>
                        
                    <h6 class="mb-2 text-center text-md-left" itemprop="name">{{ r.title }}</h6>
                    <p class="review-content text-center text-md-left" itemprop="reviewBody">
                        {{ r.review }}
                    </p>

                    <div class="rank-value-wrap pb-2 pr-3" itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating">

                        <div :class="['rank-value main-value', r.rating <=5 ? 'text-red' : 'text-green' ]">
                            <span v-if="r.rating <= 3" class="icon icon-sad mr-1"></span>
                            <span v-if="r.rating > 3 && r.rating <= 6" class="icon icon-poker-face mr-1"></span>
                            <span v-if="r.rating > 6"class="icon icon-smile1 mr-1"></span>

                            <meta itemprop="worstRating" content = "1">
                            <span itemprop="ratingValue">{{ r.rating }}</span>
                            <meta itemprop="bestRating" content = "10">

                            <span class="review-param">
                                Overall <br>
                                rating
                            </span>
                        </div>

                        <div class="rank-value">
                            {{ r.r1 }}
                            <span class="review-param">
                                Accuracy
                            </span>
                        </div>

                        <div class="rank-value">   
                            {{ r.r2 }}
                            <span class="review-param">
                                User Interface
                            </span>
                        </div>

                        <div class="rank-value">
                            {{ r.r3 }}
                            <span class="review-param">
                                Performance
                            </span>
                        </div>

                        <div class="rank-value">
                            {{ r.r4 }}
                            <span class="review-param">
                                Innovation
                            </span>
                        </div>

                    </div>

                    <div class="pt-3 review-more">
                        <review-like v-if='r.id != yourReview.id' :r='r.id' :l='r.likes'></review-like>
                        <span v-else>&nbsp;</span>
                        <comments v-if='r.id' :conf='commentConfig' :id='r.id' :c='r.comments'></comments>
                    </div>
                </div>
            </div>
        </div>

    </div>


    <div v-if='isReady && !reviews.length' class="alert alert-info d-flex align-items-center">

        <div class="alert-icon">
            <span class="icon icon-poker-face"></span>
        </div>

        <div>
            <span class="text-bold d-block">Sorry!</span>
            <span class="text-small">There are no reviews yet. You can write the first one!</span>
        </div>

    </div>

    <review-report ref='report'></review-report>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        props : ['m'],

        created() {
           
        },

        data() {
            var me = this;

            return {
                isReady     : false,
                isLoading   : false,
                yourReview  : false,
                hasReview   : false,
                showForm    : false,

                rmdl : {
                    tool_id : me.m,
                    title   : '',
                    review  : '',
                    rating  : 5,
                    r1      : 5,
                    r2      : 5,
                    r3      : 5,
                    r4      : 5
                },

                commentConfig : {
                    preload : false,
                    alwaysOpen : 0,
                    canComment : true,
                    url : {
                        get : 'cmt:grc',
                        add : 'cmt:arc',
                        upd : 'cmt:urc'
                    }
                },

                reviews : [],
            }
        },

        methods : {

            getData() {

                this.ajax.call('tl:grv', { m : this.m }, (r) => {

                    if( r.status == 'success' ) {
                        
                        this.reviews = r.data.r;

                        if( this.user ) {
                            for( var i in this.reviews ) {
                                if( this.reviews[i].user_id == this.user.id ) {
                                    this.yourReview = this.reviews[i];
                                    this.hasReview = true;
                                    this.recalculate();
                                    break;
                                }
                            }
                        }


                        if( !this.hasReview ) {
                            this.yourReview = Object.assign({}, this.rmdl);
                        }

                        this.isReady = true;

                        if (window.location.hash == "#your-review") {
                            this.$nextTick( () => {
                                this.navigate("#your-review",700);
                            });
                        }
                    }

                })
            },

            save() {

                if( !this.user ) {
                    return;
                }

                if( this.yourReview.title.length < 5 ) {
                    $.notify("Please fill your review title ","warning")
                    $("#title").focus();
                    return;
                }

                if( this.yourReview.review.length < 10 ) {
                    $.notify("Please fill your review ","warning")
                    $("#review").focus();
                    return;
                }

                this.isLoading = true;

                this.ajax.call('rvw:sv', this.yourReview, (r) => {
                    if( r.status == 'success' ) {

                        this.isLoading = false;
                        
                        if( this.hasReview ) {

                            $.notify("Your review was updated","success");

                        } else {

                            this.yourReview.id = r.data.id;
                            this.hasReview = true;
                            $.notify("Your review was added","success");
                            this.reviews.unshift( this.yourReview );

                            let cr = parseInt( $("#rev-counter").text() );

                            $("#rev-counter").text( cr + 1 );

                        }

                        this.showForm = false;

                        bus.$emit('refresh-stats');
                    }

                })
            },

            reportReview( r ) {
                this.$refs.report.open( r );
            },

            recalculate() {
                var total = this.yourReview.r1 +
                            this.yourReview.r2 +
                            this.yourReview.r3 +
                            this.yourReview.r4;

                this.yourReview.rating = (total / 4).toFixed(2);
            },

            editYourReview() {
                this.showForm = true;

                this.$nextTick( () => {
                    this.navigate('#your-review',500);
                })
            }

        },

        watch : {
            'yourReview.title' : function(n,o) {
                if( n.length > 60 ) {
                    this.yourReview.title = this.yourReview.title.substr(0,60);
                }
            },
            'yourReview.review' : function(n,o) {
                if( n.length > 500 ) {
                    this.yourReview.title = this.yourReview.title.substr(0,500);
                }
            },
        },

        components : {
            'review-like' : require('./ReviewLike.vue').default
        }

    }
</script>
